import styled from "@emotion/styled";
import { Dialog, DialogTitle, Box, Stack } from "@mui/material";
import { cross } from "../../../assets/svgs";
import { rowSB } from "../../../GlobalStyles";
import CustomIconButton from "../../CustomIconButton";
import { subHeading } from "../../CustomTexts";
import SvgPreview from "../../SvgPreview";
import { Transition } from "../QuestionRawContainer";
import AllQuestionPreview from "./AllQuestionPreview";
import QueList from "./QueList";
import { useState } from "react";

export const CustomDialog = styled(Dialog)<any>(() => ({
  "& .MuiDialog-paper": {
    margin: "0",
    padding: "0px",
    backgroundColor: "#F4F5FA",
    height: "100dvh",
    overflow: "hidden",
  },
}));
const Preview: React.FC<{ onClose: any }> = ({ onClose }) => {
  const [selectedQue, setQue] = useState<any>(null);
  return (
    <CustomDialog
      fullScreen={true}
      open={true}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <DialogTitle
        sx={{ m: 0, p: "20px 15px 15px", ...rowSB, bgcolor: "white" }}
        id="customized-dialog-title"
      >
        {subHeading({
          text: "Preview Proofreaded Content",
          size: "1.1rem",
          weight: "600",
        })}
        <CustomIconButton
          onClick={onClose}
          noHover={true}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
          content={<SvgPreview svg={cross} />}
        />
      </DialogTitle>
      <Box
        height="calc(100% - 63px)"
        mt="4px"
        width="100%"
        display="flex"
        flexDirection="row"
        gap="12px"
      >
        <Stack
          minWidth={"350px"}
          maxWidth={"350px"}
          height={"100%"}
          boxShadow="rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px"
          bgcolor="white"
        >
          <QueList setQue={setQue} question={selectedQue} />
        </Stack>{" "}
        <Stack
          width={"calc(100% - 350px)"}
          sx={{
            display: "flex",
            flexDirection: "row",
          }}
          height={"100%"}
        >
          <AllQuestionPreview question={selectedQue} />
        </Stack>
      </Box>
    </CustomDialog>
  );
};
export default Preview;
